import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "ask-the-investigation",
  courseId: "investigations",
  order: 8,
  title: "Ask the investigation",
  subtitle: "Chat with citations",
  summary:
    "When you need to know where something was said across hundreds of calls and documents, ask in plain language. The assistant searches every transcript, document, and table, and each answer carries numbered citations you can click.",
  learn: [
    "Open a chat thread and ask a question",
    "Click citations to open the source at the exact spot",
    "Know what the assistant can and cannot see",
  ],
  minutes: 3,
  releasedAt: "2026-08-24T00:00:00.000Z",
  gate: "investigations",
  body: [
    {
      type: "paragraph",
      text: "Chat is the fastest way to find a thread running through many files: every mention of a place, what a piece of slang seems to mean, who is being paid. Ask it the way you would ask a partner who has read everything.",
    },
    {
      type: "steps",
      items: [
        "Click **Ask** in the investigation header, or open the Chat tab.",
        "Type a question, such as \"Every time anyone mentions the storage unit, with dates.\" or \"Which calls mention money going to Marcus?\"",
        "Watch the tool steps as the assistant searches, reads transcripts, pulls table rows, or checks video events.",
        "Click a citation number to open the call at that second, the document at that page, or the spreadsheet rows.",
      ],
    },
    {
      type: "paragraph",
      text: "Citations are numbered once per thread, so [3] points to the same source every time it appears.",
    },
    {
      type: "callout",
      tone: "note",
      title: "What it can see",
      text: "The assistant only sees this investigation, and never a file marked privileged. Its answers are grounded in the citations. If it cannot find support, it says so instead of guessing.",
    },
    {
      type: "callout",
      tone: "tip",
      title: "Coded language",
      text: "Slang does not search well by meaning, so \"What does 'handle that' seem to mean in these calls?\" will not always get a clean answer. Ask about the context instead (\"calls right after the visit on the 14th\") and read the transcripts it cites.",
    },
    {
      type: "paragraph",
      text: "Chat threads are private to you. They are included, as logs, in the discovery package when you export it. See Export and discovery for what else goes in, and Calls for checking a citation against the audio.",
    },
  ],
  related: ["calls-and-transcripts", "export-and-discovery", "read-the-brief"],
};

export default lesson;
